export function generateEndpointAccount(address) {
    return `/cosmos/auth/v1beta1/accounts/${address}`;
}
//# sourceMappingURL=account.js.map